<template>
  <div id="app" :class="isBgGray ? 'bg-light-gray-2' : isWebView ? 'app-wrapper' : ''">
    <div class="app-wrapper-bg">
      <global-navigation v-if="isWebView" />

      <main class="app-container">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import ApiMixin from '@/mixins/api';
import CommonApiMixin from '@/mixins/commonApi';
import UserMixin from '@/mixins/user';
import GlobalNavigation from '@/components/GlobalNavigation.vue';
import sleep from '@/utils/sleep';

export default {
  name: 'App',

  components: {
    GlobalNavigation,
  },

  mixins: [ApiMixin, CommonApiMixin, UserMixin],

  data() {
    return {
      rating: 0,
      feedback: '',
      getCookieRunVal: '',
      isWebView: false,
      isBgGray: false,
    };
  },

  created() {
    // this.getCookieRun();
    this.getCookieRunVal = this.$getUUID('sessionId');
    this.$nextTick(() => {
      if (this.getCookieRunVal !== '') {
        this.queryCacheManager(this.getCookieRunVal, 'CacheManagerQuery');
      }
    });
  },

  watch: {
    $route() {
      const location = this.$route.path;
      console.log('location流量:', this.$route.path);

      // 把路由存在緩存中，此處你可以console.log看出路由變化
      sessionStorage.setItem('hashLocation', location);

      this.isWebView = !this.$route.path.includes('Taipeipass');
      this.isBgGray = this.$route.path.includes('Taipeipass/receiptDetail');
      if (!this.isWebView && !this.isBgGray) {
        $('html').css('background-color', '#fff');
      } else {
        $('html').css('background-color', '#f4f4f4');
      }

      if (this.isBgGray) {
        document.title = '收據明細';
      } else if (this.$route.path.includes('receiptRecord')) {
        document.title = '收據';
      } else if (this.$route.path.includes('receiptReturnHome')) {
        document.title = '歸戶';
      } else if (this.$route.path.includes('receiptConfirmation')) {
        document.title = '收據歸戶';
      }
    },
  },

  methods: {
    ...mapMutations('login', ['changeLogin']),
    async queryCacheManager(sessionId, type, UserData) {
      console.log('打API檢查是否有此資料', sessionId);
      try {
        this.apiStart();
        await sleep(1);
        this.apiStop();
        const data = {
          sessionId,
          sessionSource: 'H',
        };
        const url = '/GovEReceipt/CacheManagerService/Query';
        const method = 'post';
        this.axiosServiceSend(data, url, method, type, UserData);
      } catch (error) {
        this.apiStop();
        console.error(error);
      }
    },
    // 使用共用API結果
    CommonApiResult(result, type, otherObj) {
      console.log(otherObj);
      let UserData = {};
      let chanExpireDate;
      let cacheData;
      switch (type) {
        case 'CacheManagerQuery': // 有cookie狀態
          console.log('result.data', result.data);
          console.log('UserData:', UserData);
          if (result.data.rtnCode === '0000') {
            UserData = JSON.parse(result.data.object.dataMessage);
            chanExpireDate = result.data.object.sessionExpireDate;
            cacheData = {
              isLogin: true,
              chanExpireDate,
              userName: UserData.userName,
              refresh: UserData.refreshToken,
              rpHmId: UserData.hmId,
            };
            this.changeLogin(cacheData);
            console.log('UserData.hmId', UserData.hmId);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>
